<template>
	<div class="byline">
		<a :href="contexte.urls.homepage" target="_blank" class="byline__image">
			<img :src="contexte.logo" alt="Logo de Contexte" />
		</a>
		<div class="byline__text" v-html="contexte.signature">
		</div>
	</div>	
</template>
<script>
	import logoPollotron from "../assets/logo_pollotron.svg"
	const contexteHomepageUrl = 'https://www.contexte.com'

	export default {
		name: 'Byline',
		data: function() {
			return {
				contexte: {
					logo: logoPollotron,
					urls: {
						homepage: contexteHomepageUrl,
					},
					signature: 'Propulsé par <a href="' + contexteHomepageUrl + '">Contexte</a>'
				},
			}
		},
	}
</script>
<style lang="scss">
	$fontTitle: 'alternate-gothic-atf', sans-serif;
	$greySpecial: #706F6F;
	.main--light {
		.byline {
			&__image {
				flex: 0 0 140px;
			}
		}
	}
	.byline {
		top: 5px;
		right: 0;
		position: absolute;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		align-items: center;
		> * {
			margin: 0 10px;
		}
		&__text {
			font-family: $fontTitle;
			text-transform: uppercase;
			color: $greySpecial;
			font-size: 1em;
			text-align: right
		}
		&__image {
			flex: 0 0 160px;
			display: block;
			margin-top: 0px;
			img {
				width: 100%;
			}
		}
	}
	@media screen and (max-width: 600px)  {
		.byline { 
			display: block;
			position: relative;
			top: unset;
			right: unset;
			margin-bottom: 1.4em;
			&__text {
				text-align: center;
				margin: .6em auto 0;
			}
			&__image {
				margin: 2em auto 0;
				width: 130px;
			}
		}
	}
</style>